import { render, staticRenderFns } from "./AddBatch.vue?vue&type=template&id=c6b022c4&"
import script from "./AddBatch.vue?vue&type=script&lang=js&"
export * from "./AddBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports